import React from "react";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { CRMColors } from "../../../../models/CRMColors";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { TCasesDocumentFile1 } from "../../../../../../domain/codecs/CasesDocument";
import { Border } from "../../../BuildingBlocks/Border";
import { Padding } from "../../../BuildingBlocks/Padding";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { CRMFileAttachment } from "../CRMFileAttachment/CRMFileAttachment";
import { CRMButtonQuaternary } from "../../../CRMButtonQuaternary/CRMButtonQuaternary";

type TFileAttachmentInsertedProps = {
    index: number;
    file: TCasesDocumentFile1;
    onRemove: () => void;
}

export const CRMFileAttachmentInserted = (props: TFileAttachmentInsertedProps): JSX.Element => (
    <Border type="bottom" definition={`1px solid ${CRMColors.NEUTRAL_8}`}>
        <Padding type="bottom" spacing={CRMSpacing.LARGE}>
            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                <SpacingColumn spacing={CRMSpacing.TINY}>
                    {/* We use max width here to keep the enquiry paragraph text short enough per line for readability  */}
                    <MaxWidth width="450px">
                        <CRMFileAttachment
                            tagPrefix={`${props.index}. `}
                            file={props.file}
                        />
                    </MaxWidth>
                </SpacingColumn>

                <SpacingRow>
                    <CRMButtonQuaternary
                        label="Remove"
                        icon="delete"
                        onClick={props.onRemove}
                    />
                </SpacingRow>
            </SpacingColumn>
        </Padding>
    </Border>
);
